<script>
  export default {
    name: 'remote-printing',
    data: () => ({
      fileTypes: [
        { type: 'Adobe Acrobat PDF', extension: '.pdf' },
        { type: 'Adobe Illustrator diagram', extension: '.ai' },
        { type: 'Adobe Photoshop image', extension: '.psd' },
        { type: 'Apple Keynote presentation', extension: '.key' },
        { type: 'Apple Numbers spreadsheet', extension: '.numbers' },
        { type: 'Apple Pages document', extension: '.pages' },
        { type: 'Comma-separated Values (CSV)', extension: '.csv' },
        { type: 'Electronic Publishing', extension: '.epub' },
        { type: 'Encapsulated Postscript', extension: '.eps' },
        { type: 'GIF image', extension: '.gif' },
        { type: 'JPEG image', extension: '.jpg  .jpeg' },
        { type: 'Markdown document', extension: '.md' },
        { type: 'Microsoft Excel spreadsheet', extension: '.xls  .xlsx' },
        {
          type: 'Microsoft PowerPoint Presentation',
          extension: '.ppt  .pptx  .pps  .ppsx'
        },
        { type: 'Microsoft Visio diagram', extension: '.vsd' },
        { type: 'Microsoft Word document', extension: '.docx  .doc  .wps' },
        { type: 'Open Office document', extension: '.odt' },
        { type: 'OpenDocument document', extension: '.odp' },
        { type: 'OpenDocument spreadsheet', extension: '.ods' },
        { type: 'PNG image', extension: '.png' },
        { type: 'PostScript', extension: '.ps' },
        { type: 'PPM image', extension: '.ppm' },
        { type: 'Rich Text document', extension: '.rtf' },
        { type: 'TIFF image', extension: '.tif  .tiff' },
        { type: 'Unformatted text document', extension: '.txt' },
        { type: 'Vector diagram', extension: '.svg' },
        { type: 'Windows image file (bitmap)', extension: '.bmp' },
        { type: 'WordPerfect document', extension: '.wpd' }
      ],
      tableHeaders: [
        {
          text: 'File Type',
          align: 'start',
          sortable: true,
          value: 'type'
        },
        { text: '	File Extension', sortable: true, value: 'extension' }
      ]
    }),
    computed: {},
    methods: {},
    created() {}
  }
</script>

<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="d-flex flex-column align-center">
        <h1 class="text-h2 primary--text font-weight-bold">Remote Printing</h1>

        <v-card flat max-width="140ch" rounded class="mt-12">
          <img height="250px" src="https://media.eipl.org/site/images/services/remote-print.png" class="d-block my-8 mx-auto" />

          <v-card-text class="black--text text-body-1 text-left py-4">
            <v-sheet color="transparent" class="mb-10">
              <p class="primary--text font-weight-bold text-h6">
                EIPL offers remote printing services from virtually any location or device. <br />Please find instructions for all available methods below.
              </p>
            </v-sheet>
            <v-sheet color="transparent" class="mb-10">
              <h2 class="text-h5 primary--text font-weight-bold">Pricing</h2>
              <ul>
                <li>BLACK/WHITE: $.10 per/page</li>
                <li>COLOR: $.25 per/page</li>
              </ul>
            </v-sheet>
            <h2 class="text-h5 primary--text font-weight-bold mb-4">Directions</h2>
            <v-sheet color="transparent" class="mb-10">
              <v-sheet color="transparent" class="font-weight-bold primary--text"><v-icon color="primary" class="mr-2">mdi mdi-email-newsletter</v-icon>EMAIL</v-sheet>
              <p class="primary--text font-weight-bold text-body-2 font-italic">Emails and/or email attachments can be printed directly.</p>

              <ul>
                <li>
                  Send a new email with all documents added as attachments or forward an existing email to one of the following addresses;
                  <ul>
                    <li>
                      BLACK/WHITE:
                      <a href="mailto:eipl-bw@ewprints.com">eipl-bw@ewprints.com</a>
                    </li>
                    <li>
                      COLOR:
                      <a href="mailto:eipl-color@ewprints.com">eipl-color@ewprints.com</a>
                    </li>
                  </ul>
                </li>
                <li>
                  <!-- You will be sent a release code for the email message and each attachment. -->
                  You will be sent a confirmation email once submitted.
                  <ul>
                    <li>If confirmation has not been received within a few minutes check spam/junk mail folder.</li>
                  </ul>
                </li>
                <!-- <li>Retrieve your print from the computer lab using the supplied release code.</li> -->
                <li>Retrieve your print from the computer lab using your email address.</li>
              </ul>
            </v-sheet>

            <!-- <v-sheet color="transparent" class="mb-10">
              <v-sheet color="transparent" class="font-weight-bold primary--text"><v-icon color="primary" class="mr-2">mdi mdi-cellphone</v-icon>MOBILE</v-sheet>
              <p class="primary--text font-weight-bold text-body-2 font-italic">Mobile apps available soon. Please use the email or Upload methods.</p>
            </v-sheet> -->

            <v-sheet color="transparent" class="mb-10">
              <v-sheet color="transparent">
                <v-sheet color="transparent" class="font-weight-bold primary--text"><v-icon color="primary" class="mr-2">mdi mdi-cloud-upload</v-icon>UPLOAD</v-sheet>
                <p class="primary--text font-weight-bold text-body-2 font-italic">Documents can be uploaded using any modern web browser.</p>
              </v-sheet>

              <ul>
                <li>
                  Go to:
                  <a target="blank" href="https://print.princh.com/?pid=110750">https://print.princh.com/?pid=110750</a>
                </li>
                <li>Click the large button labeled: "Click here to select and upload a file".</li>
                <li>Select all files to be printed.</li>
                <li>Adjust any settings for each document if required (color mode, # copies, etc).</li>
                <li>Check the "Accept terms and conditions box" and click the green "continue" button.</li>
                <li>Enter your email address when prompted.</li>
                <li>Retrieve your print from the computer lab using the provided email address.</li>
              </ul>
            </v-sheet>

            <v-sheet color="transparent" class="mb-10">
              <v-sheet color="transparent" class="font-weight-bold primary--text"
                ><v-icon color="primary" class="mr-2">mdi mdi-file-document-multiple</v-icon>SUPPORTED FORMATS
                <p class="primary--text font-weight-bold text-body-2 font-italic">Remote printing supports all of the most popular file formats.</p>
              </v-sheet>
              <v-data-table dense :headers="tableHeaders" hide-default-footer :items="fileTypes" :items-per-page="50" item-key="material" class="mt-8"></v-data-table>
            </v-sheet>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped></style>
